var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TitledCardBase',{attrs:{"title":_vm.$t('component.pagenotfound.title')}},[_c('img',{attrs:{"src":require("@/assets/404.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }